import React, { Component } from "react";
import "./addpost.css";

import { auth, db } from "./firebase";
import { Link, Route, Switch } from "react-router-dom";
import editor from "./editor.jpg";
import academ from "./academ.jpg";
import bio from "./bio.jpg";
import chil from "./chil.jpg";
import fic from "./fic.jpg";
import life from "./layf.jpg";
import polit from "./polit.jpg";
import fan from "./fan.jpg";
import most from "./popula.jpg";
import art from "./art.jpg";
import bus from "./busines.jpg";
import envi from "./envi.jpg";
import heal from "./heal.jpg";
import grow from "./grow.jpg";
import reli from "./reli.jpg";
import tec from "./tec.jpg";
import market from "./pm.png";
import mac from "./mac.jpg";
import not from "./not.jpg";
import pdflogo from "./pdflog.png";
import Upload from "./upload";
import kitobimg1 from "./livebook.jpg";
import kitobimg2 from "./givetake.jpg";
import kitobimg3 from "./breyn.jpg";
import kitobimg4 from "./n4.jpg";
import kitobimg5 from './book5.jpg'
import usericon from './usericon.png'


import kitobn1 from "./Living in the Light_ A guide to personal transformation ( PDFDrive ) (2).pdf";
import kitobn2 from "./The Gifts of Imperfection_ Embrace Who You Are ( PDFDrive ).pdf";
import kitobn3 from "./Braiding Sweetgrass_ Indigenous Wisdom, Scientific Knowledge and the Teachings of Plants ( PDFDrive ).pdf";
import kitobn4 from "./The Purpose-Driven Life_ What on Earth Am I Here For_ ( PDFDrive ).pdf";
import kitobn5 from "./Boundaries_ When to Say Yes, How to Say No to Take Control of Your Life ( PDFDrive ).pdf"


class Addpost extends Component {
  state = {
    keyword: "",
    ochiq: false,
    ppp: false,
    ppp1: false,
    ppp2: false,
    ppp3:false,
    user:null,
    kitob1: [
      {
        name: "Living in the Light: A guide to personal transformation",
        pages: "258 Pages / 2001 / 2.74 MB / 616,200 Downloads",
        word: "Transformation / Shakti Gawain, with Lurel King. - Completely rev such as The Path of Transformation",
      },
    ],
    kitob2: [
      {
        name: "Give and Take: Why helping others drives our success",
        pages: "260 Pages / 2011 / 1.57 MB /  680,415 Downloads",
        word: "Give and Take is brimming with life-changing insights. One of the great secrets of life is that those who ",
      },
    ],
    kitob3: [
      {
        name: "Braiding Sweetgrass: Indigenous Wisdom, Scientific Knowladge and the Teaching...",
        pages: "473 Pages / 2017 / 2.13 MB / 142.527 Downloads",
        word: "Braiding_Sweetgrass-_-Robert Kimmerer.pdf Braiding Sweetgrass ...",
      },
    ],
    kitob4: [
      {
        name: "-Driven Life: What on Earth Am I Fere For?",
        pages: "78 Pages / 2003 / 3.65 MB / 347.997 Downloads",
        word: "The New York Times Bestseller, who over 3 million sold, now available in a lare print editinon the",
      },
    ],
    kitob5: [
      {
        name: "Boundaries: When to Say Yes, How To Say No to take Control of Your Life",
        pages: "357 Pages / 2001 / 1.9 MB / 534.974 Downloads",
        word: "Dr_Henry_Cloud,_Dr_John_Townsend_Boundaries_W(zlibraryyexau2g3p_onion).pdf Boundaries Henry",
      },
    ]
  };
  handlelogout = () => {
    auth.signOut().then(()=>{
      window.location.href="/"
    })
    this.setState({
      user:null
    })
  };

  handleQidiruv = (event) => {
    this.setState({
      keyword: event.target.value,
    });
  };

  handlemoreinfo = () => {
    this.setState({
      ochiq: !this.state.ochiq,
    });
  };
  handlePPP = () => {
    this.setState({
      ppp: !this.state.ppp,
    });
  };
  handlePPP1 = () => {
    this.setState({
      ppp1: !this.state.ppp1,
    });
  };
  handlePPP2 = () => {
    this.setState({
      ppp2: !this.state.ppp2,
    });
  };
  handlePPP3 = () => {
    this.setState({
      ppp3: !this.state.ppp3,
    });
  };



  render() {
    return (
      <React.Fragment>
        <div className="umumiy">
          <div className="container">
            <div className="navbar container">
              <div className="left container">
                <div>
                  <Link to="/" className="pdf">
                    <img src={pdflogo} alt="" />
                  </Link>
                </div>
                <div className="qwe">
                  <span className="msr">
                    <input
                      onChange={(event) => {
                        this.setState({ keyword: event.target.value });
                      }}
                      className="mase"
                      type="text"
                      placeholder="Search for books, tutorials, manuals and authors in 80,565,367 files"
                    />
                    <i className="fas fa-search"></i>
                  </span>
                </div>
              </div>
              <div className="rightadd container">
                <span className="userknp">
                   <i className="fa fa-user-circle"></i>
                    <button className="newuserbtn">newuser</button>
                </span>
                <Link to="/upload">
                  <button className="vfff">Upload</button>
                </Link>
               <span> <button className="vfff" onClick={this.handlelogout}>Log Out</button></span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Switch>
            
            <Route exact path="/">
              <div className="bek">
                <div className="conte">
                  <div className="mainpart conte">
                    <div className="leftmain conte">
                      <span className="weekbooks">
                        <i className="fas fa-gem"></i>
                        <h3>Best Books of the Week</h3>
                      </span>
                      <div className="kitobga conte">
                        {this.state.ochiq === true
                          ? this.state.kitob1.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf12">
                                    <div className="ag">
                                      <img
                                        onClick={this.handlemoreinfo}
                                        src={kitobimg1}
                                        alt=""
                                      />
                                    </div>
                                    <div className="shifu">
                                      <p className="cv">
                                        Living in the Light: A guide to <br />
                                        personal transformation
                                      </p>{" "}
                                      <br />
                                      <p className="green">
                                        258 Pages / 2001 / 2.74 MB / 616.200
                                        Downloads / English
                                      </p>
                                      <p className="mualif">by David Sargent</p>
                                      <p className="plus">
                                        + <span>Self-improvment</span> +{" "}
                                        <span>Editor's Picks</span> +{" "}
                                        <span>Most Popular</span>
                                      </p>
                                      <span className="imporbtn">
                                        <button className="prbtn">
                                          Preview
                                        </button>
                                        <a href={kitobn1} download>
                                          <button className="dobtn">
                                            Download
                                          </button>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf12">
                                      <div className="ag">
                                        <img
                                          onClick={this.handlemoreinfo}
                                          src={kitobimg1}
                                          alt=""
                                        />
                                      </div>
                                      <div className="shifu">
                                        <p className="cv">
                                          Living in the Light: A guide to <br />
                                          personal transformation
                                        </p>{" "}
                                        <br />
                                        <p className="green">
                                          258 Pages / 2001 / 2.74 MB / 616.200
                                          Downloads / English
                                        </p>
                                        <p className="mualif">
                                          by David Sargent
                                        </p>
                                        <p className="plus">
                                          + <span>Self-improvment</span> +{" "}
                                          <span>Editor's Picks</span> +{" "}
                                          <span>Most Popular</span>
                                        </p>
                                        <span className="imporbtn">
                                          <button className="prbtn">
                                            Preview
                                          </button>
                                          <a href={kitobn1} download>
                                            <button className="dobtn">
                                              Download
                                            </button>
                                          </a>
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })
                          : this.state.kitob1.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf">
                                    <div>
                                      <img
                                        onClick={this.handlemoreinfo}
                                        src={kitobimg1}
                                        alt=""
                                      />
                                    </div>
                                    <div className="ici">
                                      <h5
                                        onClick={this.handlemoreinfo}
                                        className="title"
                                      >
                                        {event.name}
                                      </h5>
                                      <p className="page">{event.pages}</p>
                                      <p className="word">{event.word}</p>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf">
                                      <div>
                                        <img
                                          onClick={this.handlemoreinfo}
                                          src={kitobimg1}
                                          alt=""
                                        />
                                      </div>
                                      <div className="ici">
                                        <h5
                                          onClick={this.handlemoreinfo}
                                          className="title"
                                        >
                                          {event.name}
                                        </h5>
                                        <p className="page">{event.pages}</p>
                                        <p className="word">{event.word}</p>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })}
                  </div>  
                      <div className="kitobga conte">
                        {this.state.ppp === true
                          ? this.state.kitob2.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf12">
                                    <div className="ag">
                                      <img
                                        onClick={this.handlePPP}
                                        src={kitobimg2}
                                        alt=""
                                      />
                                    </div>
                                    <div className="shifu">
                                      <p className="cv">
                                        Give and Take: WHY HELPING <br />
                                        OTHERS DRIVES OUR SUCCESS
                                      </p>{" "}
                                      <br />
                                      <p className="green">
                                        260 Pages / 2011 / 1.57 MB / 681.629
                                        Downloads / English
                                      </p>
                                      <p className="plus">
                                        + <span>Editor's Picks</span> +{" "}
                                        <span>Most Popular</span>+{" "}
                                        <span>Religion</span> + +{" "}
                                        <span>Spirituelty</span>
                                      </p>
                                      <span className="imporbtn">
                                        <button className="prbtn">
                                          Preview
                                        </button>
                                        <a href={kitobn2} download>
                                          <button className="dobtn">
                                            Download
                                          </button>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf12">
                                      <div className="ag">
                                        <img
                                          onClick={this.handlePPP}
                                          src={kitobimg2}
                                          alt=""
                                        />
                                      </div>
                                      <div className="shifu">
                                        <p className="cv">
                                          Living in the Light: A guide to <br />
                                          personal transformation
                                        </p>{" "}
                                        <br />
                                        <p className="green">
                                          258 Pages / 2001 / 2.74 MB / 616.200
                                          Downloads / English
                                        </p>
                                        <p className="mualif">
                                          by David Sargent
                                        </p>
                                        <p className="plus">
                                          + <span>Self-improvment</span> +{" "}
                                          <span>Editor's Picks</span> +{" "}
                                          <span>Most Popular</span>
                                        </p>
                                        <span className="imporbtn">
                                          <button className="prbtn">
                                            Preview
                                          </button>
                                          <a href={kitobn2} download>
                                            <button className="dobtn">
                                              Download
                                            </button>
                                          </a>
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })
                          : this.state.kitob2.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf">
                                    <div>
                                      <img
                                        onClick={this.handlePPP}
                                        src={kitobimg2}
                                        alt=""
                                      />
                                    </div>
                                    <div className="ici">
                                      <h5
                                        onClick={this.handlePPP}
                                        className="title"
                                      >
                                        {event.name}
                                      </h5>
                                      <p className="page">{event.pages}</p>
                                      <p className="word">{event.word}</p>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf">
                                      <div>
                                        <img
                                          onClick={this.handlePPP}
                                          src={kitobimg2}
                                          alt=""
                                        />
                                      </div>
                                      <div className="ici">
                                        <h5
                                          onClick={this.handlePPP}
                                          className="title"
                                        >
                                          {event.name}
                                        </h5>
                                        <p className="page">{event.pages}</p>
                                        <p className="word">{event.word}</p>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })}
                      </div>

                      <div className="kitobga conte">
                        {this.state.ppp1 === true
                          ? this.state.kitob3.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf12">
                                    <div className="ag">
                                      <img
                                        onClick={this.handlePPP1}
                                        src={kitobimg3}
                                        alt=""
                                      />
                                    </div>
                                    <div className="shifu">
                                      <p className="cv">
                                        Braiding Sweetgrass: Indigenous <br />
                                        Wisdom, Scientific Knowlande and <br />
                                        the Teachings of Plants
                                      </p>{" "}
                                      <br />
                                      <p className="green">
                                        473 Pages / 2017 / 2.03 MB / 142.203
                                        Downloads / English
                                      </p>
                                      <p className="plus">
                                        + <span>Editor's Picks</span> +{" "}
                                        <span>Environment</span>
                                      </p>
                                      <span className="imporbtn">
                                        <button className="prbtn">
                                          Preview
                                        </button>
                                        <a href={kitobn3} download>
                                          <button className="dobtn">
                                            Download
                                          </button>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf12">
                                      <div className="ag">
                                        <img
                                          onClick={this.handlePPP1}
                                          src={kitobimg3}
                                          alt=""
                                        />
                                      </div>
                                      <div className="shifu">
                                        <p className="cv">
                                          Braiding Sweetgrass: Indigenous <br />
                                          Wisdom, Scientific Knowlande and{" "}
                                          <br />
                                          the Teachings of Plants
                                        </p>{" "}
                                        <br />
                                        <p className="green">
                                          473 Pages / 2017 / 2.03 MB / 142.203
                                          Downloads / English
                                        </p>
                                        <p className="plus">
                                          + <span>Editor's Picks</span> +{" "}
                                          <span>Environment</span>
                                        </p>
                                        <span className="imporbtn">
                                          <button className="prbtn">
                                            Preview
                                          </button>
                                          <a href={kitobn3} download>
                                            <button className="dobtn">
                                              Download
                                            </button>
                                          </a>
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })
                          : this.state.kitob3.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf">
                                    <div>
                                      <img
                                        onClick={this.handlePPP1}
                                        src={kitobimg3}
                                        alt=""
                                      />
                                    </div>
                                    <div className="ici">
                                      <h5
                                        onClick={this.handlePPP1}
                                        className="title"
                                      >
                                        {event.name}
                                      </h5>
                                      <p className="page">{event.pages}</p>
                                      <p className="word">{event.word}</p>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf">
                                      <div>
                                        <img
                                          onClick={this.handlePPP1}
                                          src={kitobimg3}
                                          alt=""
                                        />
                                      </div>
                                      <div className="ici">
                                        <h5
                                          onClick={this.handlePPP1}
                                          className="title"
                                        >
                                          {event.name}
                                        </h5>
                                        <p className="page">{event.pages}</p>
                                        <p className="word">{event.word}</p>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })}
                      </div>
                      <h3 className="passion">
                        Books on finding Your Passion and Purpose in Life
                      </h3>
                      <div className="kitobga conte">
                        {this.state.ppp2 === true
                          ? this.state.kitob4.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf12">
                                    <div className="ag">
                                      <img
                                        onClick={this.handlePPP2}
                                        src={kitobimg4}
                                        alt=""
                                      />
                                    </div>
                                    <div className="shifu">
                                      <p className="cv">
                                        The Purpose-Driven Life? What on <br />
                                        Earth Am I Here For?
                                      </p>{" "}
                                      <br />
                                      <p className="green">
                                        473 Pages / 2003 / 3.65 MB / 345.873
                                        Downloads / English
                                      </p>
                                      <p className="plus">
                                        + <span>Editor's Picks</span> +{" "}
                                        <span>Environment</span> +
                                        <span>Most Popular</span>
                                      </p>
                                      <span className="imporbtn">
                                        <button className="prbtn">
                                          Preview
                                        </button>
                                        <a href={kitobn4} download>
                                          <button className="dobtn">
                                            Download
                                          </button>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf12">
                                      <div className="ag">
                                        <img
                                          onClick={this.handlePPP2}
                                          src={kitobimg4}
                                          alt=""
                                        />
                                      </div>
                                      <div className="shifu">
                                        <p className="cv">
                                          The Purpose-Driven Life? What on{" "}
                                          <br />
                                          Earth Am I Here For? the Teachings of
                                          Plants
                                        </p>{" "}
                                        <br />
                                        <p className="green">
                                          473 Pages / 2003 / 3.65 MB / 345.873
                                          Downloads / English
                                        </p>
                                        <p className="plus">
                                          + <span>Editor's Picks</span> +{" "}
                                          <span>Environment</span> +
                                          <span>Most Popular</span>
                                        </p>
                                        <span className="imporbtn">
                                          <button className="prbtn">
                                            Preview
                                          </button>
                                          <a href={kitobn4} download>
                                            <button className="dobtn">
                                              Download
                                            </button>
                                          </a>
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })
                          : this.state.kitob4.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf">
                                    <div>
                                      <img
                                        onClick={this.handlePPP2}
                                        src={kitobimg4}
                                        alt=""
                                      />
                                    </div>
                                    <div className="ici">
                                      <h5
                                        onClick={this.handlePPP2}
                                        className="title"
                                      >
                                        {event.name}
                                      </h5>
                                      <p className="page">{event.pages}</p>
                                      <p className="word">{event.word}</p>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf">
                                      <div>
                                        <img
                                          onClick={this.handlePPP2}
                                          src={kitobimg4}
                                          alt=""
                                        />
                                      </div>
                                      <div className="ici">
                                        <h5
                                          onClick={this.handlePPP3}
                                          className="title"
                                        >
                                          {event.name}
                                        </h5>
                                        <p className="page">{event.pages}</p>
                                        <p className="word">{event.word}</p>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })}
                      </div>
                
                      <div className="kitobga conte">
                        {this.state.ppp3 === true
                          ? this.state.kitob5.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf12">
                                    <div className="ag">
                                      <img
                                        onClick={this.handlePPP3}
                                        src={kitobimg5}
                                        alt=""
                                      />
                                    </div>
                                    <div className="shifu">
                                      <p className="cv">
                                        Boundaries: When to Say Yes, How <br />
                                        to Say No to Take Control Your <br />
                                        Life
                                      </p>{" "}
                                      <br />
                                      <p className="green">
                                        357 Pages / 2001 / 1.9 MB / 532.855
                                        Downloads / English
                                      </p>
                                      <p className="plus">
                                        + <span>Editor's Picks</span> +{" "}
                                        <span>Environment</span> +
                                        <span>Most Popular</span>
                                      </p>
                                      <span className="imporbtn">
                                        <button className="prbtn">
                                          Preview
                                        </button>
                                        <a href={kitobn5} download>
                                          <button className="dobtn">
                                            Download
                                          </button>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf12">
                                      <div className="ag">
                                        <img
                                          onClick={this.handlePPP3}
                                          src={kitobimg5}
                                          alt=""
                                        />
                                      </div>
                                      <div className="shifu">
                                        <p className="cv">
                                        Boundaries: When to Say Yes, How <br />
                                        to Say No to Take Control Your <br />
                                        Life
                                        </p>{" "}
                                        <br />
                                        <p className="green">
                                        357 Pages / 2001 / 1.9 MB / 532.855
                                        Downloads / English
                                        </p>
                                        <p className="plus">
                                          + <span>Editor's Picks</span> +{" "}
                                          <span>Environment</span> +
                                          <span>Most Popular</span>
                                        </p>
                                        <span className="imporbtn">
                                          <button className="prbtn">
                                            Preview
                                          </button>
                                          <a href={kitobn5} download>
                                            <button className="dobtn">
                                              Download
                                            </button>
                                          </a>
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })
                          : this.state.kitob5.map((event) => {
                              if (this.state.keyword === "") {
                                return (
                                  <div className="inf">
                                    <div>
                                      <img
                                        onClick={this.handlePPP3}
                                        src={kitobimg5}
                                        alt=""
                                      />
                                    </div>
                                    <div className="ici">
                                      <h5
                                        onClick={this.handlePPP3}
                                        className="title"
                                      >
                                        {event.name}
                                      </h5>
                                      <p className="page">{event.pages}</p>
                                      <p className="word">{event.word}</p>
                                    </div>
                                  </div>
                                );
                              } else {
                                if (
                                  event.name
                                    .toUpperCase()
                                    .includes(this.state.keyword.toUpperCase())
                                ) {
                                  return (
                                    <div className="inf">
                                      <div>
                                        <img
                                          onClick={this.handlePPP3}
                                          src={kitobimg5}
                                          alt=""
                                        />
                                      </div>
                                      <div className="ici">
                                        <h5
                                          onClick={this.handlePPP3}
                                          className="title"
                                        >
                                          {event.name}
                                        </h5>
                                        <p className="page">{event.pages}</p>
                                        <p className="word">{event.word}</p>
                                      </div>
                                    </div>
                                  );
                                }
                              }
                            })}
                      </div>
                
                
                
                    </div>

                    <div className="rightprem">
                      <div className="klarall">
                        <p>
                          <span href="https://www.pdfdrive.com/request-a-book">
                            Pdfdrive:hope
                          </span>{" "}
                          Give books away. Get books you wont.
                        </p>
                        <div className="hamakitob">
                          <div>
                            <a href="https://www.pdfdrive.com/category/113">
                              <span className="poo">
                                <img src={editor} alt="" />{" "}
                                <p>Editor's Picks</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/6">
                              <span className="poo">
                                <img src={academ} alt="" />{" "}
                                <p>Academic & Education</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/16">
                              <span className="poo">
                                <img src={bio} alt="" /> <p>Biograhpy</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/17">
                              <span className="poo">
                                <img src={chil} alt="" />{" "}
                                <p>Children & Youth</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/11">
                              <span className="poo">
                                <img src={fic} alt="" />{" "}
                                <p>Fiction & Literature</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/19">
                              <span className="poo">
                                <img src={life} alt="" /> <p>Lifestyle</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/15">
                              <span className="poo">
                                <img src={polit} alt="" />{" "}
                                <p>Politics & Laws</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/15">
                              <span className="poo">
                                <img src={fan} alt="" />{" "}
                                <p>Science & Research</p>
                              </span>
                            </a>
                          </div>
                          <div>
                            <a href="https://www.pdfdrive.com/category/112">
                              <span className="pooo">
                                <img src={most} alt="" /> <p>Most Popular</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/1">
                              <span className="pooo">
                                <img src={art} alt="" /> <p>Art</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/3">
                              <span className="pooo">
                                <img src={bus} alt="" />{" "}
                                <p>Business & Career</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/18">
                              <span className="pooo">
                                <img src={envi} alt="" /> <p>Environment</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/8">
                              <span className="pooo">
                                <img src={heal} alt="" />{" "}
                                <p>Health & Fitness</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/4">
                              <span className="pooo">
                                <img src={grow} alt="" /> <p>Personal Growth</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/10">
                              <span className="pooo">
                                <img src={reli} alt="" /> <p>Religion</p>
                              </span>
                            </a>
                            <a href="https://www.pdfdrive.com/category/5">
                              <span className="pooo">
                                <img src={tec} alt="" /> <p>Technology</p>
                              </span>
                            </a>
                          </div>
                        </div>
                        <p className="inbo">
                          Get Top Trending Free Books in Your Inbox
                        </p>
                        <span className="emalga">
                          <input type="text" placeholder="Enter you email" />
                          <button>Subscribe</button>
                        </span>
                        <a href="https://www.pdfdrive.com/app">
                          <img className="mar" src={market} alt="" />
                        </a>
                        <p className="trendingtoday">Trending Today</p>
                        <span className="macb">
                          <img src={mac} alt="" />
                          <p className="perfor">
                            Performance is King: Join The World's Leading <br />
                            Native Ad Network-Revcontent
                          </p>
                          <p className="rev">Revcontent</p>
                        </span>
                        <span className="macb">
                          <img src={not} alt="" />
                          <p className="perfor">
                            Join Revcontent: Join The World's Fastest <br />{" "}
                            Growing Native Ad Network-Revcontent
                          </p>
                          <p className="rev">Revcontent</p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dddd">
                    <div className="donatefooter conte">
                      <div className="donin">
                        <img className="pdflog" src={pdflogo} alt="" />

                        <div>
                          <p>Company</p>
                          <a href="https://www.pdfdrive.com/home/about">
                            About
                          </a>
                          <br />
                          <a href="https://www.pdfdrive.com/app">
                            Mobile App
                          </a>{" "}
                          <br />
                          <a href="https://www.pdfdrive.com/home/terms">
                            Terms & Privacy
                          </a>
                        </div>
                        <div>
                          <p>Social</p>
                          <a href="https://twitter.com/pdfdrive">Twitter</a>
                          <br />
                          <a href="https://www.facebook.com/pdfdrive">
                            Facebook
                          </a>{" "}
                          <br />
                          <span className="donher">
                            <a href="https://www.pdfdrive.com/donate">Donate</a>
                            <i className="fa fa-heart"></i>
                          </span>
                        </div>
                        <div>
                          <p>Help</p>
                          <a href="https://www.pdfdrive.com/home/contact">
                            Contact Us
                          </a>
                          <br />
                          <a href="https://www.pdfdrive.com/home/contact">
                            Feedback
                          </a>{" "}
                          <br />
                          <a href="https://www.pdfdrive.com/home/dmca">
                            DMCA & Copyright
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Route>
            <Route path="/upload" component={Upload} />
          </Switch>
        </div>
      </React.Fragment>
    );
  }
}
export default Addpost;
